import React, { useMemo, useState } from 'react';
import { SideBar, SideBarMenuItem, SideBarMenuItemText, SideBarTitle } from 'condolivre-ds';
import styles from './MenuSideBar.module.scss';
import { getUser } from '@/helpers/cookies';
import { filterMenus } from '@/components/MenuSideBar/menu';
import { useRouter } from 'next/router';
import { usePartner } from '@/providers/Partner';
import Image from 'next/image';

export const MenuSideBar: React.FC = () => {
    const router = useRouter();
    const partner = usePartner();
    const [subMenuActive, setSubMenuActive] = useState<string | null>(null);

    const user = getUser();
    const menuLinks = useMemo(() => {
        return filterMenus(user?.role || [], partner.root.sidebar.icons, [
            {
                id: 'suppliers',
                label: partner.root.condoindica.menu
            }
        ]);
    }, [partner]);

    const handleToogle = (path) => (isActive) => {
        setSubMenuActive(isActive ? path : null);
    };

    const [isHambOpen, setIsHambOpen] = useState(false);
    const hambOpenHandler = () => {
        setIsHambOpen((prevIsHambOpen) => !prevIsHambOpen);
    };

    return (
        <SideBar
            className={`admpanel-sidebar ${styles.sidebar} ${
                isHambOpen ? `${styles.SideBar__active} active` : ''
            }`}
            variant={'admpanel'}
            data-testid={'sidebar-menu'}>
            <div className="admpanel-logo">
                <Image
                    src={partner.root.sidebar.image.src}
                    width={partner.root.sidebar.image.width}
                    height={partner.root.sidebar.image.height}
                    alt={partner.company.information.line_one}
                />
            </div>
            <SideBarTitle className={`${styles.sideBarTitle} admpanel-sideBarTitle`}>
                <span>Portal das Administradoras</span>
                <div onClick={hambOpenHandler} className={styles.hamburger_menu}>
                    <input className={styles.menu__toggle} id="menu__toggle" type="checkbox" />
                    <label className={styles.menu__btn} htmlFor="menu__toggle">
                        <span></span>
                    </label>
                </div>
            </SideBarTitle>
            {menuLinks.map(({ label, icon, iconDark, path, items, id }, index) => {
                const isActive = subMenuActive
                    ? subMenuActive == path
                    : router.pathname.includes(path);
                let classNames = [styles.SideBarMenuItem, 'menu__item'];
                if (isHambOpen) {
                    classNames = [...classNames, styles.SideBar__active, 'menu__active'];
                }
                if (isActive) {
                    classNames = [...classNames, styles.SideBar__selected, 'menu__selected'];
                }

                return (
                    <SideBarMenuItem
                        className={classNames.join(' ')}
                        key={index}
                        href={items ? '#' : path}
                        label={label}
                        id={id}
                        icon={isActive ? icon : iconDark}
                        onToogle={handleToogle(path)}
                        active={isActive}>
                        {items &&
                            items.map((item, index) => {
                                return (
                                    <SideBarMenuItemText
                                        data-testid={`sub-item-${item.id}`}
                                        label={item.label}
                                        href={item.path}
                                        key={`sub-item-${index}`}
                                    />
                                );
                            })}
                    </SideBarMenuItem>
                );
            })}
        </SideBar>
    );
};

export default MenuSideBar;
